module.exports = __webpack_public_path__ + "static/media/png-icon.f62a224a.svg";